import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'; 
import HttpApi from 'i18next-http-backend';
 
i18n
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(HttpApi)
  // connect with React
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: (process.env.NODE_ENV !== 'production'),
 
    lng: 'en',
    fallbackLng: 'en',
    whitelist: ['en', 'de'],
 
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
 
export default i18n;